export const DIRECTORY_WATCHER_RETRY_INTERVAL = 60 * 1000;
